// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/trading.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-justify {
    text-align: justify;
}


/* @media screen and (min-width: 720px){
    .qvani-refral-rwrd{
        margin-top: 6rem!important;
    }
    
} */

@media screen and (max-width: 650px){
    .rewrds-para{
        text-align: justify!important;
    }
    
}

.join-bg{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 12px;
    margin: 0px 10px 33px;
}

.join-bg > button{
    background: #F7A601;
    border-radius: 9px;
    padding: 10px;
    display: flex;
    gap: 4px;
    align-items: center;
    font-weight: 700;
    border: none;
}
.yellow{
    color: #F7A601;
}`, "",{"version":3,"sources":["webpack://./src/otherPages/Rewards/Rewards.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;;AAGA;;;;;GAKG;;AAEH;IACI;QACI,6BAA6B;IACjC;;AAEJ;;AAEA;IACI,yDAAwD;IACxD,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,cAAc;AAClB","sourcesContent":[".text-justify {\n    text-align: justify;\n}\n\n\n/* @media screen and (min-width: 720px){\n    .qvani-refral-rwrd{\n        margin-top: 6rem!important;\n    }\n    \n} */\n\n@media screen and (max-width: 650px){\n    .rewrds-para{\n        text-align: justify!important;\n    }\n    \n}\n\n.join-bg{\n    background-image: url(\"../../assets/Images/trading.png\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 12px;\n    margin: 0px 10px 33px;\n}\n\n.join-bg > button{\n    background: #F7A601;\n    border-radius: 9px;\n    padding: 10px;\n    display: flex;\n    gap: 4px;\n    align-items: center;\n    font-weight: 700;\n    border: none;\n}\n.yellow{\n    color: #F7A601;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
